<template>
  <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
    <v-form v-bind="this.$attrs">
      <div class="grid-wrapper">
        <div class="time-box">
          <SelectDateFilter @changeDate="dateChange"></SelectDateFilter>
        </div>
        <SelectItems :items="priceSelect" label="Từ" @changeItem="val => priceChange(val, 'start')"></SelectItems>
        <SelectItems :items="priceSelect" label="Đến" @changeItem="val => priceChange(val, 'end')"></SelectItems>
      </div>
      <div v-if="error.isError" class="d-flex flex-wrap justify-end mt-4 flex-gap" style="color: red; font-size: 14px">
        {{ error.message }}
      </div>
    </v-form>
    <div class="d-flex flex-wrap justify-end mt-8 flex-gap">
      <v-btn class="ml-6" dark depressed color="#0D47A1" @click="filter">
        <v-icon left>mdi-filter</v-icon>Áp dụng</v-btn
      >
    </div>
  </v-card>
</template>
<script>
import SelectDateFilter from '@/modules/import-order/SelectDateFilter.vue'
import SelectItems from '../../components/samnec/SelectItems.vue'
import { priceSelect } from '@/helpers/data.js'
import { mapState, mapActions } from 'vuex'
export default {
  components: { SelectDateFilter, SelectItems },
  data() {
    return {
      date: {
        start: '',
        end: ''
      },
      price: {
        start: null,
        end: null
      },
      error: {
        isError: false,
        message: ''
      }
    }
  },
  computed: {
    ...mapState({
      searchQuery(state) {
        return state['verifyImport'].searchQuery
      },
      itemsPerPage(state) {
        return state['verifyImport'].itemsPerPage
      }
    }),
    priceSelect: priceSelect
  },
  methods: {
    ...mapActions({
      fetchVerifyOrders: 'verifyImport/fetchItems',
      countVerifyOrders: 'verifyImport/countItems',
      setSearchQuery: 'verifyImport/setSearchQuery',
      getStats: 'verifyImport/getStat'
    }),
    dateChange(val) {
      this.date = val
    },
    priceChange(val, type) {
      type === 'start' ? (this.price.start = val) : (this.price.end = val)
    },
    async filter() {
      if (this.price.start && this.price.end && this.price.end < this.price.start) {
        this.error.isError = true
        this.error.message = 'Giá tiền cuối phải lớn hơn giá tiền đầu'
        return null
      } else {
        this.error.isError = false
        this.error.message = ''
        const params = {
          ...this.searchQuery,
          createdAt_gte: this.date.start,
          createdAt_lte: this.date.end,
          expectedWorth_gte: this.price.start,
          expectedWorth_lte: this.price.end
        }
        this.setSearchQuery({ ...params })
        setTimeout(async () => {
          await this.fetchVerifyOrders({ _start: 0, _limit: this.itemsPerPage, ...params })
          await this.countVerifyOrders({ ...params })
          await this.getStats({ ...params })
        }, 200)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.grid-wrapper {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 8px;

  @media (max-width: 900px) and (min-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 599px) {
    grid-template-columns: repeat(1, 1fr);
  }
}

.time-box {
  grid-column: span 2;
  @media (max-width: 599px) {
    grid-column: span 1;
  }
}
</style>
